import { baseApi } from "./base.api";

export const labTestApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchLabTests: build.query({
      query: (params) => ({ url: "/lab-tests/fetch", method: "GET", params }),
      providesTags: ["LabTest"],
    }),
    fetchAllLabTests: build.query({
      query: () => ({ url: "/lab-tests/fetch/all", method: "GET" }),
      providesTags: ["LabTest"],
    }),
    fetchTrashedLabTests: build.query({
      query: (params) => ({ url: "/lab-tests/fetch/trashed", method: "GET", params }),
      providesTags: ["LabTest"],
    }),
    fetchLabTestById: build.query({
      query: (id) => ({ url: `/lab-tests/fetch/${id}`, method: "GET" }),
      providesTags: ["LabTest"],
    }),
    createLabTest: build.mutation({
      query: (body) => ({ url: "/lab-tests/create", method: "POST", body }),
      invalidatesTags: ["LabTest", "Permission"],
    }),
    updateLabTest: build.mutation({
      query: ({ id, body }) => ({ url: `/lab-tests/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["LabTest", "Permission"],
    }),
    restoreLabTest: build.mutation({
      query: (id) => ({ url: `/lab-tests/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["LabTest"],
    }),
    bulkRestoreLabTests: build.mutation({
      query: (body) => ({ url: "/lab-tests/bulk-restore", method: "POST", body }),
      invalidatesTags: ["LabTest"],
    }),
    deleteLabTest: build.mutation({
      query: (id) => ({ url: `/lab-tests/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["LabTest"],
    }),
    bulkDeleteLabTests: build.mutation({
      query: (body) => ({ url: "/lab-tests/bulk-delete", method: "POST", body }),
      invalidatesTags: ["LabTest"],
    }),
    destroyLabTest: build.mutation({
      query: (id) => ({ url: `/lab-tests/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["LabTest"],
    }),
    bulkDestroyLabTests: build.mutation({
      query: (body) => ({ url: "/lab-tests/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["LabTest"],
    }),
  }),
});

export const {
  useFetchLabTestsQuery,
  useFetchAllLabTestsQuery,
  useFetchTrashedLabTestsQuery,
  useFetchLabTestByIdQuery,
  useCreateLabTestMutation,
  useUpdateLabTestMutation,
  useRestoreLabTestMutation,
  useBulkRestoreLabTestsMutation,
  useDeleteLabTestMutation,
  useBulkDeleteLabTestsMutation,
  useDestroyLabTestMutation,
  useBulkDestroyLabTestsMutation,
} = labTestApi;
